import { useEffect, useState } from "react";
import prop from "ramda/src/prop";
import pick from "ramda/src/pick";
import equals from "ramda/src/equals";
import filter from "ramda/src/filter";

import { useNetwork } from "../../hooks/useNetwork";
import {
  useNetworkContext,
} from "../../contexts/NetworkContext/context";

import type { MatchDate } from "./types";
import { usePaginationHandler } from "../../hooks/usePaginationHandler";
import { useTablePaginationContext } from "../TablePagination/context";

export const useMatchDates = () => {
  const [{ rows, rowsSameDate }, setRows] = useState<{ rows: MatchDate[], rowsSameDate: any }>({ rows: [], rowsSameDate: null });
  const [isLoading, setIsLoading] = useState(false);
  const [showArchived, setShowArchived] = useState<boolean>(false);
  const { selectedNetwork } = useNetwork();
  const { networks } = useNetworkContext();
  const { page, setPage, perPage, setPages } = useTablePaginationContext();
  const { selectedRows, pages } = usePaginationHandler(rows, page, perPage);

  useEffect(() => {
    if (!selectedNetwork.l1Id) return;
    setIsLoading(true);
    setPage(1);
    const rows = networks.map(
      pick(["l2Id", "l2Name", "matchingStartDate", "matchingEndDate", "usersInNetwork", "activationStartDate", "activationEndDate", "matchingRoundStatus"])
    );
    const rowsSameDate = filter(({ matchingStartDate, matchingEndDate }) => !!matchingStartDate && !!matchingEndDate && equals(matchingStartDate, matchingEndDate), rows)
      .map(prop('l2Name'))
      .join(', ');

    const sortedRows = [
      rows.filter(x => x.matchingRoundStatus === "MATCHING"),
      rows.filter(x => x.matchingRoundStatus === "UPCOMING"),
      rows.filter(x => x.matchingRoundStatus === "ACTIVE"),
      rows.filter(x => x.matchingRoundStatus === "CLOSED"),
      rows.filter(x => x.matchingRoundStatus === "ARCHIVED")
    ].flat();

    // Filter out archived rows if showArchived is false
    const filteredRows = showArchived
      ? sortedRows
      : sortedRows.filter(row => row.matchingRoundStatus !== "ARCHIVED");

    setRows({
      rows: filteredRows,
      rowsSameDate
    });
    setIsLoading(false);
  }, [selectedNetwork.l1Id, networks, showArchived]);

  useEffect(() => {
    setPages(pages);
    setPage(1);
  }, [pages.length]);

  const handleToggleArchiveChange = (_: any, checked: boolean) => setShowArchived(checked);

  return {
    isLoading,
    rowsSameDate,
    rows: selectedRows,
    showArchived,
    handleToggleArchiveChange,
  };
};
